var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndesignIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{fill:#4d8c9f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M25.62,28.14c0,4.19,2.1,5.86,4.52,5.86,.8,0,1.59-.15,2.17-.37v-11.39c-.48-.22-1.15-.33-1.88-.33-2.87,0-4.81,2.45-4.81,6.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M43.1,0H6.9C3.09,0,0,3.09,0,6.9V43.1C0,46.91,3.09,50,6.9,50H43.1c3.81,0,6.9-3.09,6.9-6.9V6.9C50,3.09,46.91,0,43.1,0ZM17.7,36.82c0,.23-.06,.34-.29,.34h-3.37c-.19,0-.26-.11-.26-.34V12.83c0-.23,.1-.26,.26-.26h3.41c.19,0,.26,.04,.26,.26v23.99Zm18.37-1.08c-2.01,1.15-4.27,1.82-6.38,1.82-4.68,0-8.03-3.01-8.03-9.2,0-5.38,3.41-9.91,8.83-9.91,.73,0,1.28,.07,1.82,.26v-6.02l.19-.26h3.48l.16,.22v20.34c0,.78,.07,1.78,.1,2.38l-.16,.37Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndesignIcon);
export default __webpack_public_path__ + "static/media/indesign-icon.428102fb3445705492b0db963b2fce93.svg";
export { ForwardRef as ReactComponent };